<div style="display: flex;align-items: center;justify-content: space-between;padding: .5rem; color:#545454;">
    <span multilang style="font-size: 1.4rem;">{{subject}}</span>
    <mat-icon mat-dialog-close style="cursor: pointer;">close</mat-icon>
</div>
<mat-divider></mat-divider>
<div style="display: flex;flex-direction: row;height: calc(100% - 106px);">
    <div style="display: flex;padding: .5rem;flex-direction: column;color:#545454;width:30%;">
        <form style="width: 100%;display: flex;flex-direction: column;max-width: 400px;" [formGroup]="partnerForms">
            <mat-form-field style="width: 100%;" appearance="fill">
                <mat-label multilang>Absender Name</mat-label>
                <input matInput multilang deeplMode='placeholder' formControlName="name" name="name" required>
            </mat-form-field>
            <mat-form-field style="width: 100%;" appearance="fill">
                <mat-label multilang>Absender-Email</mat-label>
                <input matInput multilang deeplMode='placeholder' formControlName="from" name="from" required>
            </mat-form-field>
            <mat-form-field style="width: 100%;" appearance="fill">
                <mat-label multilang>Empfänger-Email</mat-label>
                <input matInput multilang deeplMode='placeholder' formControlName="email" name="email" required>
            </mat-form-field>
            <mat-form-field style="width: 100%;" appearance="fill">
                <mat-label multilang>cc</mat-label>
                <input matInput multilang deeplMode='placeholder' formControlName="cc" name="cc">
            </mat-form-field>
            <mat-form-field style="width: 100%;" appearance="fill">
                <mat-label multilang>Betreff</mat-label>
                <input matInput multilang deeplMode='placeholder' formControlName="subject" name="subject" required>
            </mat-form-field>
        </form>
    </div>
    <div style="margin: 0.5rem;width: 100%;">
        <div class="toolsheader">

            <button mat-icon-button (mousedown)="protect($event)" class="noselect" (click)="setStyle('bold')"
                matTooltip="Fett">
                <mat-icon>format_bold</mat-icon>
            </button>
            <button mat-icon-button (mousedown)="protect($event)" class="noselect" (click)="setStyle('italic')"
                matTooltip="Schräg">
                <mat-icon>format_italic</mat-icon>
            </button>
            <button mat-icon-button (mousedown)="protect($event)" class="noselect" (click)="setStyle('underline')"
                matTooltip="Unterstrichen">
                <mat-icon>format_underline</mat-icon>
            </button>
            <button mat-icon-button (mousedown)="protect($event)" class="noselect" (click)="setStyle('justifyFull')"
                matTooltip="Standart">
                <mat-icon>format_align_justify</mat-icon>
            </button>
            <button mat-icon-button (mousedown)="protect($event)" class="noselect" (click)="setStyle('justifyLeft')"
                matTooltip="Linksbündig">
                <mat-icon>format_align_left</mat-icon>
            </button>
            <button mat-icon-button (mousedown)="protect($event)" class="noselect" (click)="setStyle('justifyCenter')"
                matTooltip="Zentriert">
                <mat-icon>format_align_center</mat-icon>
            </button>
            <button mat-icon-button (mousedown)="protect($event)" class="noselect" (click)="setStyle('justifyRight')"
                matTooltip="Rechtsbündig">
                <mat-icon>format_align_right</mat-icon>
            </button>

            <button mat-icon-button (mousedown)="protect($event)" class="noselect" (click)="openColorPicker()"
                [style.color]="currentForeColor" matTooltip="Hintergrundfarbe-Farbe">
                <mat-icon>color_lens</mat-icon>
            </button>
            <input style="width:0;height:0;margin: 0;padding: 0;visibility:hidden;" type="color"
                [(ngModel)]="currentColor" (ngModelChange)="setColor($event)" #colorpicker>

            <select (mousedown)="protect($event)" class="noselect" [(ngModel)]="currentTitle" matTooltip="Title"
                (change)="onTitleChange($event.target['value'])">
                <option value="">Title</option>
                <option value="h1">Title 1</option>
                <option value="h2">Title 2</option>
                <option value="h3">Title 3</option>
                <option value="h4">Title 4</option>
                <option value="h5">Title 5</option>
                <option value="h6">Title 6</option>
            </select>

            <select (mousedown)="protect($event)" [(ngModel)]="currentFontSize" class="noselect"
                style="margin-left: .5rem;" matTooltip="Font size" (change)="setFontSize($event.target['value'])">
                <option value="">Size</option>
                <option value="10px">10px</option>
                <option value="11px">11px</option>
                <option value="12px">12px</option>
                <option value="13px">13px</option>
                <option value="14px">14px</option>
                <option value="15px">15px</option>
                <option value="16px">16px</option>
                <option value="17px">17px</option>
                <option value="18px">18px</option>
                <option value="19px">19px</option>
                <option value="20px">20px</option>
                <option value="21px">21px</option>
                <option value="22px">22px</option>
                <option value="23px">23px</option>
                <option value="24px">24px</option>
                <option value="25px">25px</option>
                <option value="26px">26px</option>
                <option value="27px">27px</option>
                <option value="28px">28px</option>
                <option value="29px">29px</option>
                <option value="30px">30px</option>
            </select>

            <button mat-icon-button (mousedown)="protect($event)" (click)="setStyle('insertOrderedList')"
                matTooltip="Numerierung">
                <mat-icon>format_list_numbered</mat-icon>
            </button>
            <button mat-icon-button (mousedown)="protect($event)" (click)="openLinkMenu(true, $event)" type="button"
                cdkOverlayOrigin #trigger="cdkOverlayOrigin" matTooltip="Verlinken">
                <mat-icon>insert_link</mat-icon>
            </button>

            <button mat-icon-button (mousedown)="protect($event)" (click)="saveAsModel()" type="button"
                matTooltip="Als Vorlage speichern">
                <mat-icon>save</mat-icon>
            </button>

            <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="trigger" [cdkConnectedOverlayOpen]="isOpen">
                <div style="display: flex;;width:15rem;border-radius: 0.25rem;flex-direction: row;padding: .1rem;transform: translate(-5rem, .6rem);"
                    class="mat-elevation-z2">

                    <div style="display: flex;background-color: #fff;padding: .5rem;flex-direction: column;flex-direction: column;width: 100%;
                    font-size: .9rem;">
                        <input type="url" [(ngModel)]="currentUrl">
                        <div style="display: flex;flex-direction: row;">
                            <button mat-icon-button (click)="setLink($event)">
                                <mat-icon>check</mat-icon>
                            </button>
                            <button mat-icon-button (click)="isOpen = false">
                                <mat-icon>close</mat-icon>
                            </button>
                        </div>
                    </div>
                </div>
            </ng-template>

        </div>
        @if(loading()) {
        <mat-spinner diameter="20"></mat-spinner>
        } @else {
        <div id="myEditable" (click)="checkEditor($event)" (keydown)="checkEditor($event)"
            style="border: 1px solid rgba(0,0,0,0.2);min-height: 400px;padding:0.5rem;height: calc(100% - 59px);overflow: auto;"
            [(ngModel)]="html" contenteditable>
        </div>
        }

    </div>
</div>

<div style="display: flex;justify-content: flex-end;padding: .5rem;">
    <button mat-button (click)="onNoClick()">Abbrechen</button>
    <button mat-button (click)="onOkClick()" color="primary" cdkFocusInitial
        [disabled]="partnerForms.invalid">Senden</button>
</div>